// extracted by mini-css-extract-plugin
export var container = "_c8-0";
export var icon = "_c8-1";
export var text = "_c8-2";